module.exports = __webpack_public_path__ + "assets/favicons/mstile-150x150.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/mstile-150x150.png
// module id = nNB+
// module chunks = 1